<template>
    <div>
        <page-title-bar :class-container="$vuetify.breakpoint.smAndDown ? '' : 'pa-0'">
            <template slot="actions">
                <v-text-field clearable flat solo prepend-icon="search" v-model="searchRoles" placeholder="Buscar roles" class="search-bar"></v-text-field>
                <div class="mobile-search d-none">
                    <v-tooltip top>
                        <v-btn slot="activator" icon large class="mobile-search-btn" @click="toggleSearchForm">
                            <v-icon color="grey">search</v-icon>
                        </v-btn>
                        <span>Buscar Rol</span>
                    </v-tooltip>
                </div>
                <v-tooltip top>
                    <v-btn slot="activator" icon large @click="getRoles">
                        <v-icon color="grey">ti ti-reload</v-icon>
                    </v-btn>
                    <span>Recargar Roles</span>
                </v-tooltip>
                <v-tooltip top v-if="permisos.edit">
                    <v-btn slot="activator" icon large @click="nuevoRol(null)">
                        <v-icon color="grey">ti ti-plus</v-icon>
                    </v-btn>
                    <span>Crear Rol</span>
                </v-tooltip>
            </template>
        </page-title-bar>
        <v-container fluid grid-list-xl :class="$vuetify.breakpoint.smAndDown ? 'pt-0' : 'pa-2'">
            <v-layout row wrap border-rad-sm overflow-hidden>
                <v-flex xs12>
                    <v-data-table
                            :headers="headers"
                            :items="roles"
                            hide-actions
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.name }}</td>
                            <td class="text-xs-center xs2">{{ props.item.permissions.length }}</td>
                            <td class="text-xs-center xs2">
                                <v-btn small flat icon color="warning" @click="nuevoRol(props.item.id)">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
        <app-section-loader :status="loader"></app-section-loader>
        <register-rol-dialog  v-if="permisos.edit || permisos.add" ref="dialogRegisterRol" @onSuccess="getRoles" ></register-rol-dialog>
    </div>
</template>

<script>
    export default {
        name: 'Roles',
        components: {
            RegisterRolDialog: () => import('@/components/Roles/RegisterRolDialog')
        },
        data: () => ({
            loader: false,
            searchRoles: null,
            roles: [],
            headers: [
                {
                    text: 'Nombre',
                    sortable: true,
                    value: 'consecutivo'
                },
                {
                    text: 'Permisos',
                    sortable: false,
                    value: 'permissions',
                    align: 'center',
                    class: 'xs2'
                },
                {
                    text: 'Opciones',
                    sortable: false,
                    value: 'id',
                    align: 'center',
                    class: 'xs2'
                }
            ]
        }),
        created () {
            this.getRoles()
        },
        methods: {
            getRoles () {
                this.loader = true
                this.axios.get(`roles`)
                    .then(response => {
                        this.roles = response.data
                        this.loader = false
                    }).catch(e => {
                    this.loader = false
                    this.$store.commit('snackbar', {color: 'error', message: `al recuperar los roles`, error: e})
                })
            },
            toggleSearchForm() {
                this.$store.dispatch('toggleSearchForm')
            },
            nuevoRol(id){
                this.$refs.dialogRegisterRol.open(id)
            }
        },
        computed: {
            permisos () {
                return this.$store.getters.getPermissionModule('roles')
            }
        },
        watch: {
            'searchRoles' (val) {
                this.getRoles()
            }
        },
    }
</script>

<style scoped>

</style>
